export default __webpack_public_path__ + "static/IBM-985c06738cd14420811b57b4008389c2.png";